// extracted by mini-css-extract-plugin
export default {"modal-wrapper":"DeleteFontModal_modal-wrapper__ZNj9x"};